import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Category } from '~app/modules/generic/models';
import { APP_CATEGORY_ROUTE } from '~shared/constants';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { NavigationApplicationEvent } from '~shared/modules/application-event/models';
import { ApplicationNavigationEventType } from '~shared/modules/application-event/constants';
import { environment } from '~env/environment';
import { CategoryImagesUtil } from '~app/modules/catalog/utils/category-images.util';
import {
  IMGIX_CATEGORY_PLP_PAGE_IMAGE_HEIGHT,
  IMGIX_CATEGORY_PLP_PAGE_IMAGE_WIDTH,
} from '~app/modules/catalog/constants';
import { ListTruncation } from '~app/modules/filters/models';

@Component({
  selector: 'app-search-category-children-list',
  templateUrl: './category-children-list.component.html',
  styleUrls: ['./category-children-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryChildrenListComponent implements OnChanges {
  @Input() categories: Category[];

  categoryRoute = `/${APP_CATEGORY_ROUTE}`;
  defaultCategoryImage = `${environment.cdnBaseUrl()}/images/product-catalog-placeholder.png`;

  isExpanded = false;
  hasTruncation = false;
  limitItems = ListTruncation.maxCategoriesCount;

  constructor(
    private applicationEventService: ApplicationEventService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categories']) {
      this.setDefaultState();
    }
  }

  private setDefaultState(): void {
    this.hasTruncation = ListTruncation.maxCategoriesCount < this.categories.length;
    this.isExpanded = false;
    this.limitItems = ListTruncation.maxCategoriesCount;
  }

  toggleShowList(currentListLength): void {
    this.limitItems = currentListLength === ListTruncation.maxCategoriesCount
      ? this.categories.length
      : ListTruncation.maxCategoriesCount;
    this.isExpanded = currentListLength < this.limitItems;
  }

  getSource(category: Category): string {
    return CategoryImagesUtil.getCategoryImageSrc(
      category.id,
      IMGIX_CATEGORY_PLP_PAGE_IMAGE_HEIGHT,
      IMGIX_CATEGORY_PLP_PAGE_IMAGE_WIDTH
    );
  }

  getSourceSet(category: Category): string {
    return CategoryImagesUtil.getCategoryImageSrcSet(
      category.id,
      IMGIX_CATEGORY_PLP_PAGE_IMAGE_HEIGHT,
      IMGIX_CATEGORY_PLP_PAGE_IMAGE_WIDTH
    );
  }

  onSelectCategory(category: Category): void {
    this.applicationEventService.publish(
      new NavigationApplicationEvent(
        ApplicationNavigationEventType.PLPCategoryNavigation,
        null,
        null,
        { categoryName: category.name }
      )
    );
  }
}
